// Generated by CoffeeScript 2.7.0
var AssignmentConcern;

import {
  sortAttachments
} from 'trunks/controllers/share/attachments.js';

export default AssignmentConcern = {
  _initAttachmentsAndBindEvents: function() {
    if (this._isBindAttachmentPreviewEvent) {
      return;
    }
    this._isBindAttachmentPreviewEvent = true;
    return document.body.proxy('click', '.file-field-list-item .attachments>.attachment-item', (event) => {
      var target;
      if (event._target.closest('.file-field')) { //调用file-field自己的preview
        return;
      }
      if (event._target.closest('.file-field-list-item').classList.contains('selecting')) { //in batch download selecting mode
        return;
      }
      target = DomMaster.wrap(event._target);
      if (this.attachments.length) {
        return this.displayAttachment(target);
      } else {
        return this._requestAttachmentsAndDisplay(target);
      }
    });
  },
  _requestAttachmentsAndDisplay: function(target) {
    return Skylark.Libs.Ajax.get(this._concernedAttachmentsUrl(), {
      success: (data) => {
        this.attachments = sortAttachments(data.attachments);
        return this.displayAttachment(target);
      }
    });
  }
};
